// extracted by mini-css-extract-plugin
export var pricing = "pricing-module--pricing--474fd";
export var pricingDesc = "pricing-module--pricingDesc--44e1a";
export var pricingInverse = "pricing-module--pricingInverse--5845a";
export var pricingPrice = "pricing-module--pricingPrice--714cc";
export var pricingQuantifier = "pricing-module--pricingQuantifier--f0d81";
export var pricingQuantity = "pricing-module--pricingQuantity--22606";